import axios from 'axios';

const customAxios = axios.create({
  baseURL: process.env.VUE_APP_NODE_MANAGER_SERVER_URL+"api/admin/managers/",
});
export const chargingHistoryService = {
  getChargingHistory: (data) => customAxios.post("get-charger-history", data),
  // This route is for when we implement fetching of chargerstations based on type using mutaions and getter setter methods just like every other method being used in the file
  getChargersByUserId: (data) => customAxios.post("get-charger-by-userId", data),
  getChargers: (data) => window.axios.get("get-history-all-charger", data)
  //getChargers: (data) => customAxios.post("get-charger-by-userId", data),
};

